import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { Link } from "~/components/Link";
import { getPlatformURL } from "~/routes";
import { AssetUserEvents } from "~/modules/analytics/events/assets";
import { ImageLoader } from "~/components/ImageLoader";
import { RWA_COIN_ICON } from "~/consts";
import { AssetTableRowData, TokenRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

export const PLATFORM_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> =
    {
        slug: "Platform",
        label: "Platform",
        type: ColumnTypes.string,
        tooltip: CatalogReferenceDataSlugs.platform,
        // sortsOn: AssetColumns.protocolNames,
        width: 175,
        render: (item) => {
            if (item.isAsset) {
                const token = item.tokens[0];

                // Return Emdash if no token
                if (!token) return <Emdash />;

                // Return Emdash if no platform
                const platform = token.platform;
                if (!platform) return <Emdash />;

                return (
                    <Link
                        href={getPlatformURL({ platformSlug: platform.slug })}
                        analyticsLabel={AssetUserEvents.ClickProtocolLink}
                        analyticsEventProperties={{
                            protocol: platform.name,
                        }}
                        variant="default"
                        className="flex items-center gap-2"
                    >
                        <ImageLoader
                            src={platform.icon_url || RWA_COIN_ICON}
                            alt={`${platform.name} Icon`}
                            fallbackSrc={RWA_COIN_ICON}
                            className="h-5 w-5 min-w-5 rounded-full bg-white"
                            fallbackClassName="p-0.5"
                        />
                        <div className="dg-overflow">{platform.name}</div>
                    </Link>
                );
            }

            const token = item as TokenRowData;
            return token.platform?.name || null;
        },
    };
